import styled from 'styled-components';
import { typeStyle } from '../../styles/config/typeStyles';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 94px 0;

  svg {
    width: 8px;
    margin-bottom: 2px;
  }
`;

const StyledTitle = styled.span`
  ${typeStyle['font-10']}
`;

export { StyledContainer, StyledTitle };
